import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: '/home',
            component(resolve) {
                require.ensure(['../views/home.vue'], () => {
                    resolve(require('../views/home.vue'));
                });
            },
        },
        {
            path: '/home',
            name: '/home',
            component(resolve) {
                require.ensure(['../views/home.vue'], () => {
                    resolve(require('../views/home.vue'));
                });
            },
        },
        {
            path: '/games',
            name: '/games',
            component(resolve) {
                require.ensure(['../views/games.vue'], () => {
                    resolve(require('../views/games.vue'));
                });
            },
        },
        {
            path: '/about',
            name: '/about',
            component(resolve) {
                require.ensure(['../views/about.vue'], () => {
                    resolve(require('../views/about.vue'));
                });
            },
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js